var _class, _Breadcrumbs;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { withTheme } from "styled-components";
import Box from "../../Styled/Box";
import { getParentGroups } from "../../Core/getPath";
import Text, { TextSpan } from "../../Styled/Text";
import Icon, { StyledIcon } from "../../Styled/Icon";
import Spacing from "../../Styled/Spacing";
import { RawButton } from "../../Styled/Button";
import getAncestors from "../../Models/getAncestors";
import getDereferencedIfExists from "../../Core/getDereferencedIfExists";
import { runInAction } from "mobx";
import CommonStrata from "../../Models/Definition/CommonStrata";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RawButtonAndUnderline = RawButton;
let Breadcrumbs = observer(_class = (_Breadcrumbs = class Breadcrumbs extends Component {
  async openInCatalog(items) {
    items.forEach(item => {
      runInAction(() => {
        item.setTrait(CommonStrata.user, "isOpen", true);
      });
    });
    (await this.props.viewState.viewCatalogMember(items[0])).raiseError(this.props.viewState.terria);
    this.props.viewState.changeSearchState("");
  }
  renderCrumb(parent, i, parentGroups) {
    const ancestors = getAncestors(this.props.previewed).map(ancestor => getDereferencedIfExists(ancestor));

    /* No link when it's the current member */
    if (i === parentGroups.length - 1) {
      return /*#__PURE__*/_jsx(Text, {
        small: true,
        textDark: true,
        children: parent
      });
      /* The first and last two groups use the full name */
    } else if (i <= 1 || i >= parentGroups.length - 2) {
      return /*#__PURE__*/_jsx(RawButtonAndUnderline, {
        type: "button",
        onClick: () => this.openInCatalog(ancestors.slice(i, i + 1)),
        children: /*#__PURE__*/_jsx(TextSpan, {
          small: true,
          textDark: true,
          isLink: true,
          children: parent
        })
      });
      /* The remainder are just '..' to prevent/minimise overflowing */
    } else if (i > 1 && i < parentGroups.length - 2) {
      return /*#__PURE__*/_jsx(Text, {
        small: true,
        textDark: true,
        children: "..."
      });
    }
    return null;
  }
  render() {
    const parentGroups = this.props.previewed ? getParentGroups(this.props.previewed) : undefined;
    return (
      /*#__PURE__*/
      // Note: should it reset the text if a person deletes current search and starts a new search?
      _jsxs(Box, {
        left: true,
        styledMinHeight: "32px",
        fullWidth: true,
        backgroundColor: this.props.theme.greyLighter,
        paddedHorizontally: 2.4,
        paddedVertically: 1,
        wordBreak: "break-all",
        children: [/*#__PURE__*/_jsx(StyledIcon, {
          styledWidth: "16px",
          fillColor: this.props.theme.textDark,
          glyph: Icon.GLYPHS.globe
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 1.2
        }), /*#__PURE__*/_jsx(Box, {
          flexWrap: true,
          alignItemsFlexEnd: true,
          children: parentGroups && parentGroups.map((parent, i) => /*#__PURE__*/_jsxs(Fragment, {
            children: [this.renderCrumb(parent, i, parentGroups), i !== parentGroups.length - 1 && /*#__PURE__*/_jsx(Box, {
              paddedHorizontally: 1,
              children: /*#__PURE__*/_jsx(Text, {
                small: true,
                textDark: true,
                children: ">"
              })
            })]
          }, i))
        })]
      })
    );
  }
}, _defineProperty(_Breadcrumbs, "propTypes", {
  terria: PropTypes.object,
  viewState: PropTypes.object,
  previewed: PropTypes.object,
  theme: PropTypes.object,
  t: PropTypes.func.isRequired
}), _Breadcrumbs)) || _class;
export default withTranslation()(withTheme(Breadcrumbs));